var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("childNav", {
        attrs: {
          routerName: _vm.$t("openConfig.title"),
          backFlag: false,
          languageFlag: true,
        },
      }),
      _c("div", { staticClass: "main-body" }, [
        _c(
          "div",
          { staticClass: "main-card" },
          _vm._l(_vm.functionList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "card-item",
                on: {
                  click: function ($event) {
                    return _vm.toFunction(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "img-box" }, [
                  _c("img", {
                    staticClass: "card-img",
                    attrs: { src: item.funPic },
                  }),
                ]),
                _c("div", { staticClass: "admin-text text-top" }, [
                  _c("i", { staticClass: "el-icon-menu icon-margin" }),
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(item.funName)),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }